import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/text-chatbot/PageContent.tsx");
